module.exports = __webpack_public_path__ + "static/media/thumbs-down-filled.a348c94e.svg";